import React, { useState } from 'react';
import { CheckIcon, SendIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  return <section aria-labelledby="newsletter-heading" className="relative mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 sm:py-24" data-id="element-255" data-mp="1umgxjkrhoekp">
      <Reveal data-id="element-256" data-mp="11ybdl089etlx">
        <div className="glass relative overflow-hidden rounded-3xl px-6 py-12 text-center sm:px-12 sm:py-16" data-id="element-257" data-mp="11xthc3llkfe0">
          <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 -top-32 h-64" style={{
          background: 'radial-gradient(50% 100% at 50% 100%, rgba(139,92,255,0.28) 0%, rgba(4,3,12,0) 100%)'
        }} data-id="element-258" data-mp="xxj2e1ftuen0" />
          <p className="font-tech text-xs font-semibold tracking-[0.32em] text-cyan/80" data-id="element-259" data-mp="j7206fvdbkp2">
            TRANSMISSIONS
          </p>
          <h2 id="newsletter-heading" className="mx-auto mt-5 max-w-2xl font-display text-xl leading-[1.3] text-white sm:text-2xl lg:text-[1.9rem]" data-id="element-260" data-mp="e87i5g586060">
            Get show announcements and new releases first
          </h2>
          <form onSubmit={e => {
          e.preventDefault();
          setDone(true);
        }} className="mx-auto mt-9 flex w-full max-w-lg flex-col gap-3 sm:flex-row" data-id="element-261" data-mp="jleb1s1oa8zg">
            <label htmlFor="newsletter-email" className="sr-only" data-id="element-262" data-mp="3n3oa6y40erkc">
              Email address
            </label>
            <input id="newsletter-email" type="email" required value={email} onChange={e => {
            setEmail(e.target.value);
            setDone(false);
          }} placeholder="you@orbit.com" className="w-full rounded-full border border-white/12 bg-white/[0.04] px-6 py-4 text-sm text-white placeholder:text-white/35 transition-colors duration-200 ease-out focus:border-cyan/60 focus:outline-none" data-id="element-263" data-mp="3s29d55anbpch" />
            <button type="submit" className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-violet px-7 py-4 font-tech text-sm font-semibold tracking-[0.16em] text-white shadow-neon transition-[transform,background-color] duration-200 ease-expo hover:scale-[1.03] hover:bg-violet-soft" data-id="element-264" data-mp="3denn2ucdat1i">
              {done ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-265" data-mp="2tp3mg76for4k" /> : <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-266" data-mp="2potfosathwon" />}
              {done ? 'SUBSCRIBED' : 'SUBSCRIBE'}
            </button>
          </form>
          <p aria-live="polite" className="mt-4 text-xs text-white/40" data-id="element-267" data-mp="2ynoiduenkon7">
            {done ? "You're on the list. See you at the next one." : 'No spam. Show news only.'}
          </p>
        </div>
      </Reveal>
    </section>;
}